import React from 'react'
function ReserveHero() {
  return (
    <>
      <section className='section-1 d-flex justify-content-center align-items-center text-center'>
        <article className='primaryColor col-12 py-5'>
            <h1 className='displayTitle primaryText2'>Reserve a table</h1>
            <p className='subTitle secondaryText3'>and enjoy your meal with your loved ones</p>
        </article>
      </section>
    </>
  )
}

export default ReserveHero
